import React, { useState } from 'react';
import usePrintingColorChoices from 'components/quote_builder_widget/hooks/usePrintingColorChoices';

const choiceKey = (choice) => `${choice.color_count}_${choice.extra_color_count}`;

// The printing colours the visitor asks for on the carton material they chose. One dropdown picks a color_count +
// extra_color_count pair; the pair posts as two hidden fields under the /mcc Printing form's names. A pick the new
// material cannot be printed in falls back to the server's default pair. With no choice the owner can price, only the
// hidden fields render, carrying that default.
export const usePrintingColorChoice = (widgetIdentifier, cartonMaterialUserPriceId) => {
  const printingColors = usePrintingColorChoices(widgetIdentifier, cartonMaterialUserPriceId);
  const [pickedKey, setPickedKey] = useState(null);

  if (printingColors === null) {
    return { ready: false };
  }

  const { choices, defaultChoice } = printingColors;
  const selected = choices.find((choice) => choiceKey(choice) === pickedKey) || defaultChoice;

  const hiddenFields = (
    <>
      <input type="hidden" name="color_count" value={selected.color_count} />
      <input type="hidden" name="extra_color_count" value={selected.extra_color_count} />
    </>
  );

  const onChange = (event) => { setPickedKey(event.target.value); };

  const options = choices.map((choice) => (
    <option key={choiceKey(choice)} value={choiceKey(choice)}>
      {choice.label}
    </option>
  ));

  return { ready: true, hasChoices: choices.length > 0, selectedKey: choiceKey(selected), onChange, options, hiddenFields };
};

const BasePrintingColorChooser = ({ widgetIdentifier, cartonMaterialUserPriceId, styles, selectClassName }) => {
  const { ready, hasChoices, selectedKey, onChange, options, hiddenFields } = usePrintingColorChoice(widgetIdentifier, cartonMaterialUserPriceId);

  if (!ready) {
    return null;
  }

  if (!hasChoices) {
    return hiddenFields;
  }

  return (
    <div className={styles.formGroup} data-widget-element="form-group">
      <label className={styles.label} data-widget-element="label">
        {t('quote_builder.printing')}
      </label>
      <div className={styles.inputWrapper}>
        <select
          value={selectedKey}
          onChange={onChange}
          className={selectClassName}
          data-widget-element="select"
        >
          {options}
        </select>
      </div>
      {hiddenFields}
    </div>
  );
};

export default BasePrintingColorChooser;
